import { atom } from "recoil";
import { IUserIRoute } from "../generated/Api";
import {
  User,
  IUserByUidResponse,
  ICustomCopyTemplates,
} from "../types/UserTypes";

// Overlapping property with the IUser one,
export enum InternalUserTypes {
  INTERNAL = "INTERNAL",
}

export interface IInternalUser {
  userUid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  managedUserUids: string[];
  authType: InternalUserTypes.INTERNAL;

  // Configs from the internal user in relation to the accounts he's
  // managing
  internalUserConfig: {
    [managedUserUid: string]: {
      aliasId: string;
    };
  };
}

interface IDomain {
  url: string;
}

export const LoginUserAtom = atom<IUserByUidResponse | null>({
  key: "LoginUserAtom",
  default: null,
});

export type IUserAtom = IUserIRoute & {
  domainIsVerified?: boolean;
  enableBetaFeatures?: boolean;
  billing: {
    admins?: number;
    externalUsers?: number;
    active?: boolean;
    testDriveExpiration?: number;
    testDriveActivated?: boolean;
  };

  // New property that enables multiple domains
  domains?: IDomain[];
};

export const UserAtom = atom<IUserAtom | null>({
  key: "UserAtom",
  default: null,
});

export const InternalUserAtom = atom<IInternalUser | null>({
  key: "InternalUserAtom",
  default: null,
});

export const UserCustomCopyTemplates = atom<ICustomCopyTemplates[]>({
  key: "UserCustomCopyTemplates",
  default: [],
});
